import { actions } from "./actions";
import { mutations } from "./mutations"
import { getters } from "./getters";

const state = {
    lastSync: "",
    mobiVersion : "v0",
    localPointagesfalse: -1,
    remotePointagesfalse: -1,
    localSupplementsfalse: -1,
    remoteSupplementsfalse: -1,
    localPointagesfalseOthers: -1,
    remotePointagesTrueOthers: -1,
    remotePointagesfalseOthers: -1,
    localSupplementsfalseOthers: -1,
    remoteSupplementsTrueOthers: -1,
    remoteSupplementsfalseOthers: -1,
    upgrade:""
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
